import styled from 'styled-components'
import { noTouch } from '@/assets/styles/mixins.css'

const arrowWidthDefault = '24px'

const ArrowLink = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  font-weight: var(--arrow-link-font-weight, 900);
  font-size: var(--arrow-link-font-size, 13.5px);
  letter-spacing: 0.04em;
  text-transform: var(--arrow-link-text-transform, uppercase);
  color: var(--arrow-link-color, var(--color-decor));

  &::after {
    content: '';
    display: inline-block;
    width: var(--arrow-link-arrow-width, ${arrowWidthDefault});
    height: calc(var(--arrow-link-arrow-width, ${arrowWidthDefault}) * 14 / 24);
    margin-left: 9px;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='14' viewBox='0 0 24 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 8.4h16.333V14l7-7-7-7v5.6H0v2.8z' fill='%23b69b64'/%3E%3C/svg%3E");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transform-origin: 50% 50%;
    transition: transform 0.3s ease;
  }

  ${noTouch()`
    &:hover {
      &::after {
        transform: var(--arrow-link-transform, translateX(4px));
      }
    }
  `}
`
export default ArrowLink
